import { STATIC_ASSETS_PLACEHOLDER } from "../staticAssetsPlaceholder.js";
const images = {
    background_texture: {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/wedding-guest-book/background_texture.webp`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/wedding-guest-book/optimized/background_texture.jpg`,
        width: 1920,
        height: 1080,
    },
    overlay: {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/wedding-guest-book/overlay.png`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/wedding-guest-book/optimized/overlay.png`,
        width: 13440,
        height: 7560,
    },
    photo_tab: {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/wedding-guest-book/photo_tab.webp`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/wedding-guest-book/optimized/photo_tab.png`,
        width: 156,
        height: 155,
    },
    thumbnail: {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/wedding-guest-book/thumbnail.jpg`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/wedding-guest-book/optimized/thumbnail.jpg`,
        width: 1920,
        height: 1080,
    },
    title_gold: {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/wedding-guest-book/title_gold.png`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/wedding-guest-book/optimized/title_gold.png`,
        width: 1104,
        height: 218,
    },
    "caption/center": {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/wedding-guest-book/caption/center.webp`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/wedding-guest-book/optimized/caption/center.png`,
        width: 60,
        height: 1080,
    },
    "caption/left": {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/wedding-guest-book/caption/left.webp`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/wedding-guest-book/optimized/caption/left.webp`,
        width: 930,
        height: 1080,
    },
    "caption/right": {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/wedding-guest-book/caption/right.webp`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/wedding-guest-book/optimized/caption/right.webp`,
        width: 930,
        height: 1080,
    },
    "flowers/flowers-1": {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/wedding-guest-book/flowers/flowers-1.webp`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/wedding-guest-book/optimized/flowers/flowers-1.webp`,
        width: 1602,
        height: 2600,
    },
    "flowers/flowers-2": {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/wedding-guest-book/flowers/flowers-2.webp`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/wedding-guest-book/optimized/flowers/flowers-2.webp`,
        width: 623,
        height: 1228,
    },
    "flowers/flowers-3": {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/wedding-guest-book/flowers/flowers-3.webp`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/wedding-guest-book/optimized/flowers/flowers-3.webp`,
        width: 1157,
        height: 647,
    },
    "flowers/flowers-4": {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/wedding-guest-book/flowers/flowers-4.webp`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/wedding-guest-book/optimized/flowers/flowers-4.webp`,
        width: 1156,
        height: 523,
    },
    "flowers/flowers-5": {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/wedding-guest-book/flowers/flowers-5.webp`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/wedding-guest-book/optimized/flowers/flowers-5.webp`,
        width: 1137,
        height: 726,
    },
};
const greetingTemplate = {
    type: "typeOnGreeting",
    variant: "intro",
    secondsPerCharacter: 0.1,
    minimumMessageDisplayTimeSeconds: 3,
    showLogo: true,
    sharedMessageAssets: [
        {
            url: images["flowers/flowers-5"],
            style: {
                position: "absolute",
                width: "1137px",
                height: "1080px",
                rotate: "90deg",
                left: -700,
                bottom: 0,
            },
        },
        {
            url: images["flowers/flowers-4"],
            style: {
                position: "absolute",
                width: "1156px",
                height: "523px",
                right: -300,
                top: 300,
                bottom: 0,
                rotate: "90deg",
            },
        },
    ],
};
export const weddingGuestBook = {
    version: 1,
    themeId: "wedding-guest-book",
    name: "Wedding Guest Book",
    endFadeDuration: 1,
    thumbnailUrl: `${STATIC_ASSETS_PLACEHOLDER}/compilations/theme-stills/wedding-guest-book.webp`,
    thumbnailFrame: 165,
    background: [
        {
            variant: "image",
            src: {
                full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/wedding-guest-book/background_texture.webp`,
                preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/wedding-guest-book/optimized/background_texture.jpg`,
            },
        },
    ],
    scenes: [
        {
            type: "textTransition",
            durationSeconds: 8,
            variant: "intro",
            title: {
                text: "name",
                fontFamily: "Pinyon Script",
                fontSize: 160,
                fontWeight: "medium",
                letterSpacing: "widest",
                textColor: "#896060",
                transition: "fade-character",
            },
            subtitle1: {
                text: "date",
                fontFamily: "Quattrocento",
                fontSize: 60,
                fontWeight: "light",
                letterSpacing: "widest",
                textColor: "#7e7674",
            },
            subtitle2: {
                text: "subheading",
                fontFamily: "Libre Baskerville",
                fontSize: 30,
                fontWeight: "normal",
                letterSpacing: "widest",
                textTransform: "uppercase",
                textColor: "#7e7674",
            },
            faceCollage: {
                variant: "top-bottom-static",
                borderShape: "circle",
                colorFilter: "grayscale",
                entrance: { variant: "zoom-in" },
            },
            leftImage: {
                url: images["flowers/flowers-2"],
            },
            rightImage: {
                url: images["flowers/flowers-1"],
            },
        },
        {
            ...greetingTemplate,
            variant: "intro",
        },
        {
            type: "clip-series-basic",
            showLogo: true,
        },
        {
            ...greetingTemplate,
            variant: "outro",
        },
        {
            type: "textTransition",
            durationSeconds: 8,
            variant: "outro",
            outroVariant: "darkBlue",
            title: {
                text: "name",
                fontFamily: "Pinyon Script",
                fontSize: 160,
                fontWeight: "medium",
                letterSpacing: "widest",
                textColor: "#896060",
                transition: "fade-character",
            },
            subtitle1: {
                text: "date",
                fontFamily: "Quattrocento",
                fontSize: 60,
                fontWeight: "light",
                letterSpacing: "widest",
                textColor: "#7e7674",
            },
            leftImage: {
                url: images["flowers/flowers-2"],
            },
            rightImage: {
                url: images["flowers/flowers-1"],
            },
        },
    ],
    styles: {
        textBox: {
            backgroundColor: "#fff",
            backgroundOpacity: 0.1,
            backgroundBlur: 2,
            textAlign: "center",
            textColor: "#888",
            fontFamily: "Poiret One",
            fontWeight: "bold",
            fontSize: 96,
            leading: 1.1,
            tracking: 0.05,
            custom: {
                textShadow: "0.5rem 0.5rem 0.5rem rgba(0,0,0,0.1)",
            },
        },
        clips: {
            textVariant: {
                variant: "image-stretch",
                leftUrl: images["caption/left"],
                center: {
                    variant: "stretch-y-repeat-x",
                    url: images["caption/center"],
                },
                rightUrl: images["caption/right"],
                backgroundUrl: images["background_texture"],
                maxWidthPx: 600,
                textContainerStyleOverride: {
                    height: "18rem",
                },
            },
            betweenTransition: {
                variant: "imageSequence",
                timing: { variant: "linear", durationSeconds: 1.5 },
                mask: {
                    urlPrefix: {
                        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/common/mask/{i}.png`,
                        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/common/optimized/mask/{i}.png`,
                    },
                    frameCount: 42,
                    zeroPad: 2,
                },
                overlay: {
                    urlPrefix: {
                        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/common/overlay/{i}.png`,
                        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/common/optimized/overlay/{i}.png`,
                    },
                    frameCount: 42,
                    zeroPad: 2,
                },
            },
            title: {
                backgroundColor: "#fff",
                backgroundOpacity: 0.95,
                textColor: "#555",
                fontFamily: "Pinyon Script",
                fontWeight: "medium",
                fontSize: 80,
                nudge: 2,
                textTransform: "none",
            },
            subtitle: {
                backgroundColor: "#3f3f46",
                backgroundOpacity: 0.95,
                textColor: "#555",
                fontFamily: "EB Garamond",
                fontWeight: "medium",
                fontSize: 48,
                nudge: 2,
                textTransform: "none",
            },
            scaleFactor: 0.7,
            overlay: {
                variant: "corner",
                url: images["photo_tab"].full,
                offsetUnit: "-1rem",
            },
            backgroundVariant: {
                variant: "image",
                images: [
                    [
                        {
                            url: images["flowers/flowers-1"],
                            right: -300,
                            width: "700px",
                            height: "1080px",
                            bottom: 0,
                        },
                        {
                            url: images["flowers/flowers-2"],
                            left: -200,
                            width: "639px",
                            height: "1228px",
                            top: 0,
                        },
                    ],
                    [
                        {
                            url: images["flowers/flowers-5"],
                            left: -700,
                            width: "1137px",
                            height: "1080px",
                            bottom: 0,
                            rotateDeg: 90,
                        },
                        {
                            url: images["flowers/flowers-4"],
                            right: -300,
                            width: "1156px",
                            height: "523px",
                            top: 300,
                            bottom: 0,
                            rotateDeg: 90,
                        },
                    ],
                    [
                        {
                            url: images["flowers/flowers-3"],
                            right: 0,
                            width: "1137px",
                            height: "726px",
                            bottom: -100,
                            rotateDeg: -10,
                        },
                        {
                            url: images["flowers/flowers-2"],
                            left: 0,
                            width: "639px",
                            height: "1228px",
                            bottom: 0,
                        },
                    ],
                ],
            },
        },
        watermark: {
            opacity: 0.8,
            margin: 32,
            enterTransition: {
                variant: "slide",
                direction: "from-right",
                timing: { variant: "linear", durationSeconds: 0.5 },
            },
            exitTransition: {
                variant: "slide",
                direction: "from-left",
                timing: { variant: "linear", durationSeconds: 0.5 },
            },
        },
        sceneTransition: {
            variant: "imageSequence",
            timing: {
                variant: "linear",
                durationSeconds: 1.5,
                easing: "linear",
            },
            mask: {
                urlPrefix: {
                    full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/common/mask/{i}.png`,
                    preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/common/optimized/mask/{i}.png`,
                },
                frameCount: 42,
                zeroPad: 2,
            },
            overlay: {
                urlPrefix: {
                    full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/common/overlay/{i}.png`,
                    preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/common/optimized/overlay/{i}.png`,
                },
                frameCount: 42,
                zeroPad: 2,
            },
        },
    },
    userInputFields: [
        {
            id: "name",
            type: "text",
            label: "Name of Couple",
            defaultValue: "",
            placeholder: "Jessica & David",
            required: true,
            min: 1,
            max: 35,
            preview: {
                sceneIndex: 0,
                frameOffset: 150,
            },
        },
        {
            id: "date",
            type: "date",
            label: "Wedding Date",
            defaultValue: "",
            placeholder: "Select a date",
            required: true,
            dateFormat: "MMMM dd, yyyy",
            preview: {
                sceneIndex: 0,
                frameOffset: 150,
            },
        },
        {
            id: "subheading",
            type: "text",
            label: "Subheading",
            defaultValue: "Wedding Guest Book",
            min: 0,
            max: 35,
            preview: {
                sceneIndex: 0,
                frameOffset: 150,
            },
        },
    ],
};
